/**
 * @class Controller - Base Controller class
 */
class Controller {
    /**
     *
     * @param {AppController|null} app
     */
    constructor(app) {
        if (app) {
            /**
             * @type {AppController|null}
             */
            this.app = app;
        }

        this.bindMethodsToInstance();

        // Allow the controller to specify a method to return a value to determine whether to continue instantiation of
        // the controller. 
        if (this.condition()) {
            // Alternative to constructor to avoid calling super and passing arguments etc.
            this.ready.apply(this, Array.prototype.slice.call(arguments, 1));
        }
    }

    /**
     * Allow controlllers to set a condition to determine whether to continue instantiating the controller.
     *
     * Useful for page-specific functionality.
     *
     * @return {boolean}
     */
    condition() {
        return true;
    }

    ready() {
        // To be implemented by derived classes
    }

    beforeDestroy() {
        // To be implemented in derived classes
    }

    destroyed() {
        // To be implemented in derived classes
    }

    /**
     * Iterate and bind all methods to the instance to make setting events listeners easier. Otherwise one is required
     * to bind a method to the instance so that its this context doesn't change when executed as an callback for an
     * event.
     */
    bindMethodsToInstance() {
        let prototype = this.constructor.prototype;

        Object.getOwnPropertyNames(prototype).forEach(property => {
            // Don't touch the constructor or prototype properties that aren't functions
            if (property === 'constructor' || typeof this[property] !== 'function') {
                return;
            }

            this[property] = this[property].bind(this);
        })
    }

    /**
     * Destroy the controller. Calls the beforeDestroy and destroy methods.
     */
    destroy() {
        this.beforeDestroy();

        Object.keys(this).forEach(key => {
            this[key] = null;
        });

        this.destroyed();
    }
}

export default Controller;
